var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.ea75d20fe5de1a68ee9e1cf2c43cedae.svg#b';
                    var viewUrl = 'sprites.ea75d20fe5de1a68ee9e1cf2c43cedae.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };